var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoundBlankDark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12px",
  height: "12px",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "round_blank_dark") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-34.000000, -699.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "round_blank_dark",
  transform: "translate(34.000000, 699.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  x: 0,
  y: 0,
  width: 12,
  height: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,1 C8.76142375,1 11,3.23857625 11,6 C11,8.76142375 8.76142375,11 6,11 C3.23857625,11 1,8.76142375 1,6 C1,3.23857625 3.23857625,1 6,1 Z M6,2 C3.790861,2 2,3.790861 2,6 C2,8.209139 3.790861,10 6,10 C8.209139,10 10,8.209139 10,6 C10,3.790861 8.209139,2 6,2 Z",
  id: "Oval",
  fill: "#424242",
  fillRule: "nonzero"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoundBlankDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/round_blank_dark.1c1321369b45f1e82166616ac013e556.svg";